import { PayloadAction } from "@reduxjs/toolkit";
import { Resource } from "@myRedux/networkState";

export function wasSuccessfullyFulfilledDispatch(onFulfilled: PayloadAction<any, string, {
  arg: any;
  requestId: string;
  requestStatus: 'fulfilled' | 'rejected';
}>) {
  return onFulfilled.meta.requestStatus === 'fulfilled';
} 

export function getSuccessfullyFulfilledDispatch<T extends Resource>(onFulfilled: PayloadAction<string | T | undefined, string, {
  arg: any;
  requestId: string;
  requestStatus: 'fulfilled' | 'rejected';
}>) {
  if (onFulfilled.payload && typeof onFulfilled.payload !== 'string') {
    return onFulfilled.payload;
  }
}